/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import { useStateContext } from '../../../contexts/ContextProvider';
import '../../../App.css'
import { Spinner } from '../../../AbstractElements';
import Grow from '@mui/material/Grow';
import { getQuestionnairesFn } from '../../../api/api';
import QuestionnairesTable from './QuestionnairesTable';
import AddQuestionnaires from './AddQuestionnaires';

function containsRolesDb(item) {
  return Object.prototype.hasOwnProperty.call(item, 'roles_db');
}
function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}
function isObject(item) {
  return (typeof item === 'object' && !Array.isArray(item) && item !== null);
}

const Questionnaires = () => {
  const { basictoaster, loading, setLoading, questionnaires, setQuestionnaires } = useStateContext();
  // get user db roles
  const [usrDbRoles, setUsrDbRoles] = useState([]);

  useEffect(() => {
    // set useer db role
    let userData = localStorage.getItem("user_data");
    if (userData !== null) {
      let userDataObj = JSON.parse(userData);
      if (containsRolesDb(userDataObj)) {
        setUsrDbRoles(userDataObj.roles_db);
      }
    }
    // set ab to state and use this new ab in this code
    let newAbortController = new AbortController()
    setLoading(true);
    getQuestionnairesFn(newAbortController.signal).then((resp) => {
      if (!newAbortController.signal.aborted) {
        setQuestionnaires(resp);
        setLoading(false);
      }
    }).catch((err) => {basictoaster("error", "Errore questionari", err, () => {})});
    
    // Cleanup function to abort the request when the component unmounts
    return () => {
      newAbortController.abort();
    };
  }, [])

  // ALERT
  useEffect(() => {
    if (isObject(questionnaires) && containsError(questionnaires)) {
      basictoaster("error", "Errore questionari", questionnaires.Error, setQuestionnaires)
    }
  }, [questionnaires])

  return (
    <Fragment>
    <br />
      <Breadcrumbs phish mainTitle="Questionari" parent="DomusVestra" title="Questionari" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Grow in={true}><div>
            <Card>
              <CardBody>
                {loading ? (
                  <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-1' }} />
                  </div>
                ) : (
                  <>
                    <h2><b>Questionari</b></h2><br />
                    {usrDbRoles.includes('GOSP') && (
                      <><AddQuestionnaires /><br /><br /></>
                    )}
                    <QuestionnairesTable usrDbRoles={usrDbRoles} />
                  </>
                )}
              </CardBody>
            </Card>
            </div></Grow>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Questionnaires;